import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

const baseUrl = `${environment.apiUrl}/historicoAlarmas`;

@Injectable()
export class HistoricoAlarmasService {

  constructor(private http: HttpClient) { }

  public GetById(id: number): Observable<any> {
    return this.http.get(baseUrl + "/" + id);
  }

  public GetAllTiposVariables() {
    return this.http.post<JSON>(`${baseUrl}/tiposvariables`, {}, { withCredentials: true });
  }

  public GetAllMaquinas(action: string = '', param?: string, data?: ''): Observable<any> {
    return this.http.get(baseUrl);
  }

  public GetAll(action: string = '', param?: string, data?: ''): Observable<any> {
    return this.http.get(baseUrl);
  }

  public GetAll_TiposPerdidas_DAT(action: string = '', param?: string, data?: ''): Observable<any> {
    return this.http.get(baseUrl + "/histoc");
  }

  insert(data, logo, archivo) {
    return this.http.post<any>(baseUrl + "/crear", {id: -1,  nombre: data.nombre, logo: logo, archivo: archivo}, { withCredentials: true });
  }

  filtrarAlarmas(id, fechaIni, fechaFin, idMaquina) {
    return this.http.post<any>(baseUrl + "/filtraralarmas", { id: id, fechaIni: fechaIni, fechaFin: fechaFin, idMaquina: idMaquina}, { withCredentials: true });
  }

  update(data, logo, imagen) {
    return this.http.post<any>(baseUrl + "/editar", { id:data.id, nombre: data.nombre, logo: logo, archivo : imagen  }, { withCredentials: true });
  }

  delete(data?: any): Observable<any> {
    var formData: any = new FormData();
    formData.append("ids", data.ids);
    return this.http.post<JSON>(baseUrl + "/eliminar", formData, { withCredentials: true });
  }

  public download(idMarca): Observable<any> {
    return this.http.get(baseUrl + "/logo/download/" + idMarca);
  }

}
